import { defineMessages } from "react-intl";
import { DefineMsg } from "types/types";

export const interruptionMsg: DefineMsg = defineMessages({
  cause: { id: "interruption.cause", defaultMessage: "Cause" },
  buttonFunction: {
    id: "interruption.buttonFunction",
    defaultMessage: "Fn button pressed",
  },
  buttonReset: {
    id: "interruption.buttonReset",
    defaultMessage: "Reset button pressed",
  },
  connectionClosed: {
    id: "interruption.connectionClosed",
    defaultMessage: "Connectivity lost after the app was quit",
  },
  connectionUnstable: {
    id: "interruption.connectionUnstable",
    defaultMessage: "Connectivity lost",
  },
  countdownDelayTooLong: {
    id: "interruption.countdownDelayTooLong",
    defaultMessage: "Missed target start time",
  },
  detectionBodyHeat: {
    id: "interruption.detectionBodyHeat",
    defaultMessage: "Body heat detected",
  },
  detectionWalk: {
    id: "interruption.detectionWalk",
    defaultMessage: "Walk detected",
  },
  errorGeneral: {
    id: "interruption.errorGeneral",
    defaultMessage: "General error",
  },
  errorLidarBlocked: {
    id: "interruption.errorLidarBlocked",
    defaultMessage: "Not enough free space around robot",
  },
  lampsOff: {
    id: "interruption.lampsOff",
    defaultMessage: "Internal error",
  },
  localizationLoss: {
    id: "interruption.localizationLoss",
    defaultMessage: "Lost localization",
  },
  uiInactivity: {
    id: "interruption.uiInactivity",
    defaultMessage: "Operator inactive",
  },
  uiMovement: {
    id: "interruption.uiMovement",
    defaultMessage: "Tablet movement",
  },
  uiPermission: {
    id: "interruption.uiPermission",
    defaultMessage: "Could not access iPad motion sensors",
  },
  uiUserTriggerOthers: {
    id: "interruption.uiUserTriggerOthers",
    defaultMessage: "Interrupted by operator",
  },
  uiUserTriggerWarmUp: {
    id: "interruption.uiUserTriggerWarmUp",
    defaultMessage: "Interrupted by operator during warmup",
  },
  warningLowBattery: {
    id: "interruption.warningLowBattery",
    defaultMessage: "Low battery",
  },
  unsafeTimeout: {
    id: "interruption.unsafeTimeout",
    defaultMessage: "Safe conditions not restored",
  },
  personDetection: {
    id: "interruption.personDetection",
    defaultMessage: "Person detected",
  },
});
